import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "../pages/Home/Home";
import CollectionsPage from "../pages/Collections/CollectionsPage";
import BlogsPage
from "../pages/Blogs/BlogsPage";
import BlogDetails from "../pages/BlogDetails/BlogDetails";
import LotDetails from "../pages/LotDetails";
import AboutUs from "../components/AboutFarmFox/AboutUs";
import ContactUs from "../components/ContactUs/ContactUs";
function AppRoutes() {
    return (
        <BrowserRouter>
            <Routes>
                <Route
    path="/blogs"
    element={<BlogsPage />}
/>

<Route
    path="/blog/:slug"
    element={<BlogDetails />}
/>
 <Route
                    path="/collections"
                    element={<CollectionsPage />}
                />

                <Route
                    path="/supplier"
                    element={<LotDetails/>}
                />
               <Route
               path="/about-us"
    element={<AboutUs />}
               />
               <Route
               path="/contact-us"
    element={<ContactUs />}
               />
                <Route
                    path="/"
                    element={<Home />}
                /> 

            </Routes>
        </BrowserRouter>
    );
}

export default AppRoutes;